// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"styles_imgWrapper__1wNkD","brandImgWrapper":"styles_brandImgWrapper__26vQB","img":"styles_img__2_vKW","imageWithoutStyles":"styles_imageWithoutStyles__fdeQL"};